import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { randomString } from '../../../_core/_function/randomid';
import { DataService } from '../../../_services/data.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { User } from '../../../_core/_interface/user';
import { TokenResponse } from '../../../_core/_interface/tokenSelsforce';




@Component({
  selector: 'app-parsing-building-from-json',
  templateUrl: './parsing-building-from-json.component.html',
  styleUrls: ['./parsing-building-from-json.component.css']
})
export class ParsingBuildingFromJsonComponent implements OnInit {

  // url = this.domain + '/projects_programms/54446692/original_size/ea64e4f3105e344c8f222042ecfbbee2.jpg';
  receivedJson: any;
  buildingFromJson: any;
  ifNoChanges: boolean = true;
  buildingsFromDb: any[] = [];
  showRoomsSwitcher: any[] = [""];
  selectedFiles: FileList;
  uploadIndex = -1;
  allFilesCount = 0;
  thumbMaxWidth = 120;
  thumbMaxHeight = 120;
  imageMaxWidth = 1920;
  imageMaxHeight = 1920;
  // Main task
  task: AngularFireUploadTask;
  // Progress monitoring
  percentage: Observable<number>;
  snapshot: Observable<any>;
  // Download URL
  downloadURL: Observable<string>;
  domain = 'https://crm.sehel.co.il';
  sehelProjIds = ['a246afb5-427c-4921-927b-795020264f93', 'a503d275-11a5-4283-b5d9-4b9abbd66508',
   'be91a7e2-8b70-4195-ba6b-f3e298d02767', '9a66e509-8070-46ca-974e-cbdb8e62b8d8',
    '5bcf6d3b-a9dd-4a7e-9fab-a1d2c7765c7d', 'f0877bc2-2f24-4936-b4a1-917d7995d2d7', '9ea4bf37-41ca-47d0-a02d-0aff43029b48'];
  sehelProjId = '';
  urlBuilding = '';
  urlProject = '';
  buildingName = '';

  @Input() proj: any;
  companyId = '';
  section = '0';
  galleryId = '1';
  URLimageNotSafe: string = `https://crm.sehel.co.il/projects_programms/54446692/original_size/ea64e4f3105e344c8f222042ecfbbee2.jpg`;
  postData = JSON.stringify({ "token": "spirikal-427c-4921-927b-795020264f93" });
  image: Blob;
  imageURL: SafeUrl;
  projFromJson: any;
  initializeBuildingName: void;
  sPlaneUrl: any;
  curBuildUid: string = '';
  user: User;
  counter: number = 0;

  constructor(private http: HttpClient,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private ng2ImgMax: Ng2ImgMaxService,
    private storage: AngularFireStorage,
    private db: AppFirestoreService,
    private route: ActivatedRoute,
    private auth: AuthService) {
  }

  ngOnInit(): void {
    this.companyId = this.proj.parrentId;
    this.user = this.auth.currentUserValue;




    this.runOncePerDay(); // run the code





  }

  startCheckForUpdates(){
    setTimeout(() => {
      this.sehelProjId = this.sehelProjIds.filter(sehelProjId => sehelProjId === this.proj.sehelProjId)[0];

      // ----------------------  if Not Flat Properties Page ------------------------
      if (!this.route.snapshot.params.flatId && (this.user.roles.editor || this.user.roles.admin)) {
        if (this.route.snapshot.params.buid) {
          this.curBuildUid = this.route.snapshot.params.buid;
        }
        this.sehelProjId = this.sehelProjIds.filter(sehelProjId => sehelProjId === this.proj.sehelProjId)[0];
        if (this.sehelProjId) {
          if (this.sehelProjId !== '') {
            this.urlProject = this.domain + '/api/3d/getProject/' + this.sehelProjId;
            // this.urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/' + this.buildingName;
            this.http.post(this.urlProject, this.postData).toPromise().then(data => {
              this.projFromJson = data;
              const sehelBuildingsArray = this.projFromJson.data.buildings;
              if (this.proj.sehelBuildingsArray && this.proj.sehelBuildingsArray.length > 0) {
                const ifNewBuilding = this.deepEqual(this.proj.sehelBuildingsArray, sehelBuildingsArray);
                let newBuildingsArray = [];
                sehelBuildingsArray.filter(buildingNameFromJson => {
                  let newBuildnig = this.proj.sehelBuildingsArray.filter(buildingName => buildingNameFromJson === buildingName);
                  if (newBuildnig.length < 1) {
                    newBuildingsArray.push(buildingNameFromJson)
                  }
                })
                newBuildingsArray.forEach(newBuildingName => {
                  this.proj.sehelBuildingsArray.push(newBuildingName);
                  this.dataService.updateItem(this.proj, 'markers/');
                  // this.buildingName = newBuildingName;
                  // this.urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/' + this.buildingName;
                  this.getBuilding(newBuildingName);
                })
                // -----------------  this is building page and we check if building have changes START ------------------------
                if (newBuildingsArray.length < 1 && this.curBuildUid !== '') {
                  this.dataService.getSpecBuilding(this.curBuildUid).subscribe(buildings => {
                    if (buildings[0]) {
                      this.getBuilding(buildings[0].name)
                    } else {
                      this.proj.sehelBuildingsArray.map(newBuildingName => {
                        // this.buildingName = newBuildingName;
                        // this.urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/' + this.buildingName;
                        this.getBuilding(newBuildingName);
                      })
                    }
                  })
                }
                // -----------------  this is building page and we check if building have changes END ------------------------
              } else {
                this.proj.sehelBuildingsArray = sehelBuildingsArray;
                this.dataService.updateItem(this.proj, 'markers/');
                this.proj.sehelBuildingsArray.map(newBuildingName => {
                  // this.buildingName = newBuildingName;
                  // this.urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/' + this.buildingName;
                  this.getBuilding(newBuildingName);
                })
              }
            });
          }
        }
        this.companyId = this.proj.parrentId;
        // this.startUpload();
        // this.urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/1';
        // this.getBuilding();
      }

    }, 1000);
  }


  hasOneDayPassed() {
    // get today's date. eg: "7/37/2007"
    let date = new Date().toLocaleDateString();
    let localStorageTime = localStorage.getItem('updateSehelDate');
    // if there's a date in localstorage and it's equal to the above: 
    // inferring a day has yet to pass since both dates are equal.
    if (localStorageTime === date)
      return false;

    // this portion of logic occurs when a day has passed
    localStorage.setItem('updateSehelDate', date);
    return true;
  }


  // some function which should run once a day
  runOncePerDay() {
    if (!this.hasOneDayPassed()) return false;
    // your code below
    this.startCheckForUpdates()
  }


  refreshTokenAndGetResponse() {
    this.refreshToken().subscribe({
      next: (response) => {
        // Обработайте ответ от Salesforce здесь
        // let responseObject = JSON.parse(response);
        let accessToken = response.access_token;



        this.queryProperties(response.access_token).subscribe({
          next: (response) => {
            console.log('Properties available for purchase:', response);
            // Process your response here
          },
          error: (error) => {
            console.error('Error querying properties:', error);
          }
        });



      },
      error: (error) => {
        console.error('Error:', error);
        // Обработайте ошибку здесь
      }
    });
  }

  refreshToken() {
    const url = 'https://carassorealestate.my.salesforce.com/services/oauth2/token';

    // Подготовка данных для тела запроса
    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('refresh_token', '5Aep8618d42zULhmmNUcoCwPsFNMdEEOqNxA4EdOaiTRF1zBYxOmZSpKc71WLtvIzSVy112.DYjWOTnVqIiDLzr');
    body.set('client_id', '3MVG9I9urWjeUW04nMmxsfMT0hdcUnxAZB56dRWNTlq.Dswmen6ZsSxKX_0AvO0u8V9NNxVKbSgiERXSFa0jo');
    body.set('client_secret', 'BE5E561764A6C352ED482804B2FA25DE56EDE40F8BF9506D605406EAC2F321B4');

    // Настройка заголовков
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    // Отправка запроса
    return this.http.post<TokenResponse>(url, body.toString(), { headers });
  }


  queryProperties(accessToken: string): Observable<any> {
    // const endpointUrl = "https://carassorealestate.my.salesforce.com/services/data/v56.0/query/?q=select Id,name, Property_Number__c, Building__r.Name from Property__c where Available_For_Purchase_Spirikal__c  = TRUE and Building__r.Real_Estate_Project__c  = 'a034L000001PqKAQA0'";
      //  const endpointUrl = "https://carassorealestate.my.salesforce.com/services/data/v56.0/query/?q=select Id,name, Property_Number__c, Building__r.Name, Asset_Purchasing_Status__c from Property__c where Available_For_Purchase_Spirikal__c  = TRUE and Building__r.Real_Estate_Project__c  = 'a034L000001PqKAQA0'";
       const endpointUrl = "https://carassorealestate.my.salesforce.com/services/data/v56.0/query/?q=select Id,name, Property_Number__c, Building__r.Name, Asset_Purchasing_Status__c from Property__c where Available_For_Purchase_Spirikal__c  = TRUE and Building__c  = 'a024L000004HzykQAC'";

    // Prepare the headers
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    });
  
    // Make the GET request
    return this.http.get(endpointUrl, { headers });
  }



  getBuilding(newBuildingName) {
    let urlBuilding = this.domain + '/api/3d/getBuilding/' + this.sehelProjId + '/' + newBuildingName;
    this.http.post(urlBuilding, this.postData).toPromise().then(data => {
      this.buildingName = newBuildingName;
      this.receivedJson = data;
      if (this.proj) {
        this.addFlatsToFloors(this.receivedJson.data)
      }
    });
  }

  startUpload(sPlaneUrl) {
    let newFiles = { length: 0, item: (index: number) => new File([this.image], '') };
    const files: FileList = newFiles;
    this.loadImage().subscribe((i) => {
      this.image = i;
      this.imageURL = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(this.image)
      );
      var formData = new FormData();

      // var file = new File([this.image], "name");
      const file = new File([this.image], 'image.png', {
        type: this.image.type,
      });
      files.item[0] = file;

      // temporary stop upload images ----------------------------------------------------------
      this.uploadImage(file, 'image/png', sPlaneUrl);

      if (files.length > 0) {
        this.allFilesCount = files.length;
        this.uploadIndex = -1;
        this.selectedFiles = files;
        this.uploadNext();
      }
    });
  }

  loadImage(): Observable<Blob> {
    return this.http.get(this.URLimageNotSafe, {
      responseType: 'blob',
    });
  }

  uploadImage(file: File, type: string, sPlaneUrl: any) {
    // this.section = this.proj.id;
    // The storage path
    const path = `${this.companyId}/${sPlaneUrl}/${new Date().getTime()}_${file.name}`;
    const thumbPath = `${this.companyId}/${this.section}/${new Date().getTime()}_T_${file.name}`;
    // Totally optional metadata
    const customMetadata = { title: file.name };

    // create thumb and upload
    this.ng2ImgMax.resizeImage(file, this.thumbMaxWidth, this.thumbMaxHeight).subscribe(
      result => {
        this.storage.upload(thumbPath, result, { customMetadata });
      },
      error => {
        console.log('image resize error', error);
      });

    // resize image and upload
    this.ng2ImgMax.resizeImage(file, this.imageMaxWidth, this.imageMaxHeight).subscribe(
      result => {
        this.task = this.storage.upload(path, result, { customMetadata });

        // Progress monitoring
        this.percentage = this.task.percentageChanges();
        this.snapshot = this.task.snapshotChanges();

        const fileRef = this.storage.ref(path);

        // The file's download URL
        this.task.snapshotChanges().pipe(
          finalize(() => {
            this.downloadURL = fileRef.getDownloadURL();

            const itm = { section: sPlaneUrl, galleryId: this.galleryId, path, size: file.size, type: type, thumb: thumbPath };
            this.db.collection('galleries').doc(this.companyId).collection(sPlaneUrl);
            this.db.collection('galleries').doc(this.companyId).collection(sPlaneUrl).add(itm);

            // this.uploadNext();
            console.log('888888888888888888888', this.downloadURL);
          })
        )
          .subscribe();
      },
      error => {
        console.log('image resize error', error);
      });

  }

  uploadNext() {
    this.uploadIndex++;

    if (this.uploadIndex > this.selectedFiles.length) {
      return;
    }

    const file = this.selectedFiles.item(this.uploadIndex);
    if (!file) {
      return;
    }
    let type = file.type;
    let name = file.name;

    if (name.endsWith('jpg') || name.endsWith('jpeg') || name.endsWith('png')) {
      this.uploadImage(file, 'image', this.sPlaneUrl);
    }

  }

  addFlatsToFloors(receivedJson) {
    const rs = randomString(15);
    let uploadedImages = [];
    receivedJson.forEach(flat => {
      let indexLastSlash = flat.planeUrl.lastIndexOf("/");
      if(indexLastSlash === -1) {
        indexLastSlash = flat.planeUrl.lastIndexOf("_");
      }
      let imageName = flat.planeUrl.substring(indexLastSlash + 1);
      flat.sPlaneUrl = imageName.split('.')[0];
      receivedJson.forEach(item => {
        if (flat.planeUrl === item.planeUrl) {
        }
      })
    })

    const floorsWithFlats = receivedJson.reduce((acc, flat) => {
      let flatStatus = '';
      switch (flat.saleStatus) {
        case 0:
          flatStatus = 'free';
          break;
        case 1:
          flatStatus = 'waiting';
          break;
        case 2:
          flatStatus = 'sold';
          break;
        case 3:
          flatStatus = 'sold';
          break;
        case 4:
          flatStatus = 'sold';
          break;
        case 5:
          flatStatus = 'sold';
          break;
        default:
      }
      let airDirection = '';
    
        if(flat.directionN){
          if(airDirection) {
            airDirection = airDirection + '-n'
          } else {
            airDirection = airDirection + 'n'
          }
        }
        if(flat.directionE){
          if(airDirection) {
            airDirection = airDirection + '-e'
          } else {
            airDirection = airDirection + 'e'
          }
        }
        if(flat.directionS){
          if(airDirection) {
            airDirection = airDirection + '-s'
          } else {
            airDirection = airDirection + 's'
          }
        }
        if(flat.directionW){
          if(airDirection) {
            airDirection = airDirection + '-w'
          } else {
            airDirection = airDirection + 'w'
          }
        }
    
      // switch (flat.direction) {
      //   case 0:
      //     airDirection = 'n';
      //     break;
      //   case 1:
      //     airDirection = 'ne';
      //     break;
      //   case 2:
      //     airDirection = 'e';
      //     break;
      //   case 3:
      //     airDirection = 'se';
      //     break;
      //   case 4:
      //     airDirection = 's';
      //     break;
      //   case 5:
      //     airDirection = 'sw';
      //     break;
      //   case 6:
      //     airDirection = 'w';
      //     break;
      //   case 7:
      //     airDirection = 'nw';
      //     break;
      //   default:
      // }
      let spirikalFlatFormat = {
        flatSize: flat.area,
        balconiesSize: flat.balkonArea,
        airDirection: airDirection,
        entrance: flat.entrance,
        floorNumber: flat.floor,
        gardenSize: flat.gardenArea,
        number: flat.number,
        id: flat.number,
        planeDescription: flat.planeDescription,
        prototypeName: flat.planeDescription,
        planeUrl: flat.planeUrl,
        sPlaneUrl: flat.sPlaneUrl,
        price: flat.price,
        numberOfRooms: flat.room,
        status: flatStatus,
        flatInterior: '',
        shareflatgalleryOfBuilding: true,
        buildingUid: this.sehelProjId + '-' + this.buildingName,
        projUid: this.proj.uid,
        meshtaken: false
      }
      // just for example 
      if (this.sehelProjId == 'a503d275-11a5-4283-b5d9-4b9abbd66508') {
        spirikalFlatFormat.flatInterior = "https://topeye.club/spherikal/sample/sample-cicar-sefer-inside";
      }

      if (!acc[flat.floor]) {
        acc[flat.floor] = [];
      }
      acc[flat.floor].push(spirikalFlatFormat);
      return acc;
    }, {});

    let floorsWithFlatArray = Object.keys(floorsWithFlats).map(title => ({
      floor: {
        number: +title,
        id: title,
        ranking: +title,
        panoramaView: '',
        flats: floorsWithFlats[title]
      }
    }))
    floorsWithFlatArray.forEach(floor => {
      for (let y = 0; y < floor.floor.flats.length; y++) {
        let flat = floor.floor.flats[y];
        if (this.showRoomsSwitcher.indexOf(flat.numberOfRooms) < 0 && flat.numberOfRooms != 0 && flat.numberOfRooms != undefined) {
          this.showRoomsSwitcher.push(flat.numberOfRooms);
        }
      }



      // just for example 
      if (this.sehelProjId == 'a503d275-11a5-4283-b5d9-4b9abbd66508') {
        floor.floor.panoramaView = "scene_90";
      }
      //check if the number is even
      else if (floor.floor.number % 2 == 0) {
        floor.floor.panoramaView = "scene_" + floor.floor.number;
      }
      // if the number is odd
      else {
        floor.floor.panoramaView = "scene_" + (floor.floor.number - 1);
      }
    })
    floorsWithFlatArray = floorsWithFlatArray.filter(n => n);
    const building = {
      compId: this.companyId,
      withBuilding: true,
      uid: this.sehelProjId + '-' + this.buildingName,
      name: this.buildingName,
      id: '',
      projId: this.proj.id,
      projTitle: this.proj.title,
      buildingZone: " ",
      withOutPrototype: true,
      ranking: +this.buildingName,
      showRoomsSwitcher: this.showRoomsSwitcher,
      floors: floorsWithFlatArray,
      floorsWithEditionalSettings: []
    }
    console.log(building);
    this.buildingFromJson = building;

    this.dataService.getSpecBuilding(this.buildingFromJson.uid).subscribe(buildings => {
      // need to refresh if come to building page from flat page becouse can`t to update DB and inter to loop.
      // Its happen just when user come from flat page to building page.
      // -------------  start refresh
      this.counter = this.counter + 1;
      if (this.counter === 15) {
        location.reload();
      }
      // -------------- end refresh

      building.id = buildings[0].id;
      this.buildingsFromDb = buildings;
      if (buildings[0].floorsWithEditionalSettings) {
        buildings[0].floorsWithEditionalSettings = buildings[0].floorsWithEditionalSettings.filter(n => n);
        this.buildingFromJson.floorsWithEditionalSettings = buildings[0].floorsWithEditionalSettings;
      }
      if (buildings.length > 0) {
        if (buildings[0].pathToImage) {
          // if 3D include
          this.buildingFromJson.pathToImage = buildings[0].pathToImage;
        }
        buildings[0].floors = buildings[0].floors.filter(n => n);
        this.ifNoChanges = this.deepEqual(this.buildingFromJson, buildings[0])
        console.log("deepEqual", this.deepEqual(this.buildingFromJson, buildings[0]));
      }
      if (!this.ifNoChanges) {
        if (buildings.length > 0) {
          if (buildings[0].floorsWithEditionalSettings) {
            let spirikalFloors = buildings[0].floorsWithEditionalSettings;
            building.floors.forEach(floor => {
              spirikalFloors.forEach(item => {
                if (item.floor.id === floor.floor.id) {
                  floor.floor.panoramaView = item.floor.panoramaView;

                  floor.floor.flats.forEach(flat => {
                    item.floor.flats.forEach(flat2 => {
                      if (flat.id === flat2.id) {
                        if (flat2.shareflatgallery !== undefined) {
                          flat.shareflatgallery = flat2.shareflatgallery;
                        }
                        if (flat2.shareflatgalleryOfBuilding !== undefined) {
                          flat.shareflatgalleryOfBuilding = flat2.shareflatgalleryOfBuilding;
                        }
                        if (flat2.meshtaken !== undefined) {
                          flat.meshtaken = flat2.meshtaken;
                        }
                        if (flat2.flatInterior !== undefined) {
                          flat.flatInterior = flat2.flatInterior;
                        }
                        if (flat2.curFloorPanorama !== undefined) {
                          flat.curFloorPanorama = flat2.curFloorPanorama;
                        }
                        if (flat2.buildingUid !== undefined) {
                          flat.curFloorPanorama = this.sehelProjId + '-' + this.buildingName;
                        }
                      }
                    })
                  })

                }
              })
            })
          } else {
            building.floorsWithEditionalSettings = building.floors;
          }
          this.updateBuilding(building);
        } else {
          // this.saveBuilding(building);
        }
      }
    })
    // setTimeout(() => {
    //   if (!this.ifNoChanges) {
    //     if (this.buildingsFromDb.length > 0) {
    //       this.updateBuilding(building)
    //     } else {
    //       this.saveBuilding(building)
    //     }
    //   }
    // }, 2000);


    if (!this.ifNoChanges) {
      receivedJson.forEach(flat => {
        let indexLastSlash = flat.planeUrl.lastIndexOf("/");
        let imageName = flat.planeUrl.substring(indexLastSlash + 1);
        flat.sPlaneUrl = imageName.split('.')[0];
        flat.sPlaneUrl = flat.sPlaneUrl.split('_')[1];
        this.URLimageNotSafe = flat.planeUrl;
        let ifUploaded = uploadedImages.filter(item => item === flat.sPlaneUrl);
        if (ifUploaded.length > 0) {

        } else {
          this.startUpload(flat.sPlaneUrl);
          uploadedImages.push(flat.sPlaneUrl);
        }
        receivedJson.forEach(item => {
          if (flat.planeUrl === item.planeUrl) {
          }
        })
      })
    }

    setTimeout(() => {
      this.dataService.getSpecBuilding(this.buildingFromJson.uid).subscribe(buildings => {
        this.buildingsFromDb = buildings;
        if (this.buildingsFromDb.length < 1) {
          this.saveBuilding(building);
        }
      })
    }, 2000);
  }

  deepEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (key === 'flatInterior'
        || key === 'panoramaView'
        || key === 'meshtaken'
        || key === 'shareflatgalleryOfBuilding'
        || key === 'shareflatgallery'
        || key === 'ranking'
        || key === 'curFloorPanorama') {
        object1[key] = object2[key];
      }
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = this.isObject(val1) && this.isObject(val2);

      if (
        areObjects && !this.deepEqual(val1, val2) ||
        !areObjects && val1 !== val2
      ) {
        return false;

      }
    }
    return true;
  }

  isObject(object) {
    return object != null && typeof object === 'object';
  }

  updateBuilding(building) {
    this.dataService.updateItem(building, 'buildings/');
  }

  saveBuilding(building) {
    this.dataService.addItem(building, 'buildings');
  }


}



